import BaseValidator from "./Base";

export default class RequiredValidator extends BaseValidator {
    isNotValid(value: any): boolean {
        return value === undefined || value === null || value === "" || value === false;
    }
}
